import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { AccountantChangePasswordDto } from '../../_dto/_accountant/AccountantChangePasswordDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiChangePasswordAccountant = async (
  dto: AccountantChangePasswordDto
) => {
  const params: IApiParams = {
    url: '/accountant/changePassword.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'PUT', dto);
};
